/**
 * 송금 내역 테이블
 */
import React from 'react';
import Pagination from '@/shared/components/dataDisplay/Pagination';
import { TransferHistory, SortConfig } from '../types/transfer.types';
import { formatAmount } from "@/features/system/transfer/utils/transferUtils";

interface HistoryTableProps {
    histories: TransferHistory[];
    currentItems: TransferHistory[];
    currentPage: number;
    totalPages: number;
    itemsPerPage: number;
    onPageChange: (page: number) => void;
    sortConfig: SortConfig;
    onSort: (columnKey: string) => void;
}

const HistoryTable: React.FC<HistoryTableProps> = ({
                                                       histories,
                                                       currentItems,
                                                       currentPage,
                                                       totalPages,
                                                       itemsPerPage,
                                                       onPageChange,
                                                       sortConfig,
                                                       onSort
                                                   }) => {
    const getSortIcon = (columnKey: string) => {
        if (sortConfig.columnKey !== columnKey) {
            return <i className="fas fa-sort sort-icon"></i>;
        }
        if (sortConfig.direction === 'asc') {
            return <i className="fas fa-sort-up sort-icon sort-asc"></i>;
        }
        if (sortConfig.direction === 'desc') {
            return <i className="fas fa-sort-down sort-icon sort-desc"></i>;
        }
        return <i className="fas fa-sort sort-icon"></i>;
    };

    const renderSortableHeader = (columnKey: string, label: string, className: string) => (
        <th
            className={`${className} sortable`}
            onClick={() => onSort(columnKey)}
        >
            <span className="header-content">
                {label}
                {getSortIcon(columnKey)}
            </span>
        </th>
    );

    return (
        <div className="card">
            <div className="card-body">
                <table className="table sortable-table">
                    <thead>
                    <tr>
                        {renderSortableHeader('seqNo', 'No', 'col-no')}
                        {renderSortableHeader('processDate', '처리일시', 'col-date')}
                        {renderSortableHeader('suppName', '협력사', 'col-partner')}
                        {renderSortableHeader('transferAmt', '송금액', 'col-amount')}
                        {renderSortableHeader('suppBalanceAfter', '협력사 잔액', 'col-balance')}
                        <th className="col-briefs">적요</th>
                        {renderSortableHeader('insUser', '처리자', 'col-user')}
                    </tr>
                    </thead>
                    <tbody>
                    {currentItems.length === 0 ? (
                        <tr>
                            <td colSpan={7} className="col-empty">
                                송금 내역이 없습니다.
                            </td>
                        </tr>
                    ) : (
                        currentItems.map((history, index) => (
                            <tr key={history.seqNo}>
                                <td className="col-no">
                                    {histories.length - ((currentPage - 1) * itemsPerPage + index)}
                                </td>
                                <td className="col-date">{history.processDate}</td>
                                <td className="col-partner">{history.suppName || '-'}</td>
                                <td className="col-amount amount-transfer">
                                    {formatAmount(history.transferAmt)}
                                </td>
                                <td className="col-balance">
                                    {formatAmount(history.suppBalanceAfter)}
                                </td>
                                <td className="col-briefs">{history.briefs || '-'}</td>
                                <td className="col-user">{history.insUser || '-'}</td>
                            </tr>
                        ))
                    )}
                    </tbody>
                </table>

                {totalPages > 1 && (
                    <div className="pagination-container">
                        <Pagination
                            currentPage={currentPage}
                            totalPages={totalPages}
                            onPageChange={onPageChange}
                        />
                    </div>
                )}
            </div>
        </div>
    );
};

export default HistoryTable;
